import { createContext } from 'react';
import { AuthResponse, UserInfoResponse } from '@/types/auth';
import { Organization, OrganizationWithMembership, User } from '@opp/shared';

export interface AuthContextData {
  doctor: User | null;
  token: string | null;
  organizations: Organization[] | null,
  activeOrganization: Organization | null,
  isOwner: boolean,
  setActiveOrganization: (org: OrganizationWithMembership | null, userId?: string) => void;
  isAuthenticated: boolean;
  signIn: (data: AuthResponse) => Promise<void>;
  setUserInfo: (data: UserInfoResponse) => void;
  signOut: () => void;
  updateDoctor: (doctor: User) => void;
}

export const AuthContext = createContext<AuthContextData>({} as AuthContextData);

